import { useDispatch } from "react-redux";
import { selectMachineVariantId } from "../../store/slices/machine-slice";

import clsx from "clsx";
import CheckBoxGold from "~/assets/checkbox-gold.svg";
import CheckBoxGrey from "~/assets/checkbox-grey.svg";
import { GEN_1_MACHINE_PRODUCT_VARIANT_ID } from "~/utils/constants";
import "./MachineCard.css";

const MachineCard = ({ machineProduct, machineProductVariantId, selected }) => {
  const title = machineProduct.title;
  const price = machineProduct.variants.edges[0].node.price.amount;
  const imageSrc = machineProduct.images.edges[0].node.url;

  const dispatch = useDispatch();

  return (
    <div
      className={clsx("machine-product-card", { selected })}
      onClick={() => dispatch(selectMachineVariantId(machineProductVariantId))}>
      <img src={imageSrc} alt={title} className="machine-product-image" />
      {/* <div className="machine-product-checkbox">
        {selected ? <CheckBoxGold /> : <CheckBoxGrey />}
      </div> */}
      <span className="machine-product-title">{title}</span>
      <span className="machine-product-price">${price}</span>
      <ul className="machine-product-desc">
        {machineProductVariantId === GEN_1_MACHINE_PRODUCT_VARIANT_ID ? (
          <>
            <li>
              <span>1 Bartesian premium cocktail maker</span>
            </li>
            <li>
              <span>
                5 Glass spirit bottles (900ml) with labeled spands (Vodka, Whiskey, Rum, Gin,
                Tequila)
              </span>
            </li>
            <li>
              <span>1 Removable power cord</span>
            </li>
          </>
        ) : (
          <>
            <li>
              <span>1 Bartesian Duet cocktail maker</span>
            </li>
            <li>
              <span>2 glass spirit bottles (1L) with spirit label bands</span>
            </li>
            <li>
              <span>1 removable power cord</span>
            </li>
            <li>
              <span>1 removable Bartesian bar mat</span>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default MachineCard;
